import { useIsResellerOrg } from 'src/mindtime/hooks/useIsResellerOrg';
import { useSubscriptionPermissionsContext } from 'src/mindtime/contexts/SubscriptionPermissionsContext';

export type EdrModuleAccess = {
  resolved: boolean;
  isPreviewMode: boolean;
  isSubscribed: boolean;
  isReseller: boolean;
};

/** Org-level EDR subscription gate. Preview dummy data only for unsubscribed client orgs. */
export const useEdrModuleAccess = (): EdrModuleAccess => {
  const { resolved, orgEntitlements, hasActiveSubscription } = useSubscriptionPermissionsContext();
  const isReseller = useIsResellerOrg();
  const isUnsubscribed = orgEntitlements !== null && !hasActiveSubscription;

  return {
    resolved,
    isSubscribed: resolved && hasActiveSubscription && !isReseller,
    isReseller,
    isPreviewMode: resolved && isUnsubscribed && !isReseller,
  };
};
